'use strict';

export default function f($q, $http, utils) {
  'ngInject';

  return {
    reviewLeft: function(userId, userToReviewId) {
      var GET_REQUEST_URL = utils.getApiUrl(`/reviews/${userId}/${userToReviewId}/friend`);

      var promiseArgumentFunction = (resolve, reject) => {
        if (userId == userToReviewId) {
          resolve({reviewLeft: true});
          return;
        }

        $http.get(GET_REQUEST_URL).then((response) => {
          resolve(response.data);
        }).catch((response) => {
          reject(response.data);
        });
      };

      return new $q(promiseArgumentFunction);
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/reference_check.js